(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/pix-banner/assets/javascripts/pix-banner.js') >= 0) return;  svs.modules.push('/components/racing/pix-banner/assets/javascripts/pix-banner.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const gameTypes = svs.racing.common.constants.gameTypes;
const {
  getProductName,
  getProductUrlName
} = svs.racing.common.strings;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const logger = svs.core.log.getLogger('racing:pix-banner');
const {
  fetchXpert
} = svs.racing.raceService;
const {
  format
} = svs.utils;
const {
  getNextRaceDataForProduct,
  fetchTurnover
} = svs.racing.raceService;
const getRowPrice = gameType => {
  switch (gameType) {
    case gameTypes.TOPP5:
      return 20;
    case gameTypes.TOPP2:
      return 10;
    default:
      logger.warn("Pix not supported GameType: ".concat(gameType));
      break;
  }
};

let latestPixValue;

function delay(time) {
  const extraDelay = 58000;
  return new Promise(resolve => setTimeout(resolve, time + extraDelay));
}

function parseTurnover(turnover) {
  let turnoverParsed = {
    jackpot: 0,
    currentNetSales: 0,
    showNetSales: false
  };
  if (turnover) {
    turnoverParsed = {
      jackpot: parseInt(turnover.jackpot, 10) > 0 ? format.Currency(turnover.jackpot) : undefined,
      currentNetSales: parseInt(turnover.turnover, 10) > 0 ? format.Currency(turnover.turnover) : undefined,
      showNetSales: parseInt(turnover.turnover, 10) > 100000
    };
  }
  return turnoverParsed;
}

const init = async (options, clientSideFetchedData, useDataFromClient, isDialogOpen) => {
  var _options$pix, _options$data;
  const isClient = clientSideFetchedData && useDataFromClient;

  if (options !== null && options !== void 0 && (_options$pix = options.pix) !== null && _options$pix !== void 0 && _options$pix.userProduct && options !== null && options !== void 0 && (_options$data = options.data) !== null && _options$data !== void 0 && _options$data.startTime || clientSideFetchedData !== null && clientSideFetchedData !== void 0 && clientSideFetchedData.startTime && useDataFromClient) {
    delay(dateFns.differenceInMilliseconds(new Date(useDataFromClient && clientSideFetchedData !== null && clientSideFetchedData !== void 0 && clientSideFetchedData.startTime ? clientSideFetchedData.startTime : options.data.startTime), new Date()))
    .then(() => {
      getNextRaceDataForProduct(options.pix.userProduct, (err, race) => {
        if (err) {
          logger.error('Error fetching getNextRaceDataForProduct: ', err);
        } else {
          var _race$data;
          fetchTurnover(race === null || race === void 0 || (_race$data = race.data) === null || _race$data === void 0 ? void 0 : _race$data.raceId, options.pix.userProduct, (turnoverErr, turnover) => {
            if (turnoverErr) {
              logger.error('Error fetching fetchTurnover: ', turnoverErr);
            } else {
              var _race$data2, _svs$components$dialo;
              const dataObject = _objectSpread(_objectSpread({}, race.data), {}, {
                turnover: parseTurnover(turnover),
                startTimeToDisplay: formatDate((_race$data2 = race.data) === null || _race$data2 === void 0 ? void 0 : _race$data2.startTime, true, true)
              });
              init(options, dataObject, true, Boolean((_svs$components$dialo = svs.components.dialog.api) === null || _svs$components$dialo === void 0 ? void 0 : _svs$components$dialo.el));
            }
          });
        }
      });
    })
    .catch(err => logger.error('Error setting widget delay: ', err));
  }
  const el = options.el;
  const race = isClient ? clientSideFetchedData : options.data;
  const pixDraw = race.draws.find(draw => draw.userProduct === options.pix.userProduct);
  const render = () => {
    const netSales = race.turnover.currentNetSales;
    const showTurnOver = race.turnover.showNetSales && netSales;
    const startTimeToDisplay = race.startTimeToDisplay;
    const textDivLocation = showTurnOver ? 'div.pix-net-sale-info div' : 'div.start-time';
    const htmlText = showTurnOver ? "Oms\xE4ttning ".concat(netSales) : "Startar ".concat(startTimeToDisplay);
    const element = el.find(textDivLocation);
    element.html(htmlText);
  };
  const openPixDialog = totalSystemPrice => {
    let systemSize;
    let price;
    if (totalSystemPrice.type) {
      systemSize = totalSystemPrice.type / getRowPrice(pixDraw.gameType);
      price = totalSystemPrice.type;
    } else {
      systemSize = totalSystemPrice / getRowPrice(pixDraw.gameType);
      price = totalSystemPrice;
    }
    const pixOptions = {
      drawNumber: pixDraw.drawNumber,
      draws: race.draws,
      race,
      raceStartTimeTentative: race.startTime,
      startTimeToDisplay: formatDate(race.startTime, true, true),
      price: parseInt(price, 10),
      rowPrice: getRowPrice(pixDraw.gameType),
      product: 'PMU',
      productId: 99,
      userProduct: pixDraw.userProduct,
      productName: getProductName(pixDraw.gameType),
      gameType: pixDraw.gameType,
      systemSize,
      trackName: race.meeting.track.name,
      raceNumber: race.raceNumber
    };
    fetchXpert(pixDraw.drawNumber, systemSize, (error, pixData) => {
      if (error) {
        logger.warn("Error fetching pix data: ".concat(error));
        svs.racing.pix_dialog.presentErrorDialog();
      } else {
        svs.racing.pix_dialog.init(pixOptions, pixData);
      }
    });
  };
  if (isClient) {
    render();

    if (isDialogOpen) {
      svs.racing.pix_dialog.utils.clearStorage();
      svs.components.dialog.api.close();
      openPixDialog(latestPixValue);
    }
  }
  const trackClick = () => {
    var _options$areaName;
    const areaName = (_options$areaName = options.areaName) !== null && _options$areaName !== void 0 ? _options$areaName : 'promo-placed-outside-widget';
    const pathName = window.location.pathname;
    const name = "pix-".concat(getProductUrlName(pixDraw.gameType));
    if (areaName) {
      svs.components.analytics.trackPromoClick({
        id: pathName,
        name,
        position: areaName
      });
    }
  };
  const handleClick = buttonIndex => {
    trackClick();
    svs.core.module.load('/cl/racing/pix-dialog', undefined, error => {
      if (error) {
        logger.error('Could not load pix', error);
      } else {
        latestPixValue = options.pix.values[buttonIndex];
        openPixDialog(latestPixValue);
      }
    });
  };
  const buttonCount = el.find('button.pix-button').length;
  for (let i = 0; i < buttonCount; i++) {
    el.off('click', ".pix-button[data-index=".concat(i, "]"));
    el.on('click', ".pix-button[data-index=".concat(i, "]"), () => handleClick(i));
  }
};
svs.racing.pix_banner.init = init;

 })(window);